import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./_global.scss";
import Main from "./Main";
import Loader from "./views/loader/Loader";
import LashExtensions from "./views/lashExtensions/LashExtensions";
import Events from "./views/events/Events";
import Careers from "./views/careers/Careers";
import Vendors from "./views/vendors/Vendors";

const Home = lazy(() => import("./views/home/Home"));
const SalonServices = lazy(() => import("./views/salonServices/SalonServices"));
const MobileServices = lazy(() => import("./views/mobileServices/MobileServices"));
const Wellness = lazy(() => import("./views/wellness/Wellness"));
const About = lazy(() => import("./views/about/About"));
const Contact = lazy(() => import("./views/contact/Contact"));
const Reviews = lazy(() => import("./views/reviews/Reviews"));

const SuspenseWrapper = ({ fallback, children }: { fallback?: React.ReactNode; children: React.ReactNode }) => (
  <Suspense fallback={fallback ?? <Loader />}>{children}</Suspense>
);

function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />}>
            <Route
              index
              element={
                <SuspenseWrapper>
                  <Home />
                </SuspenseWrapper>
              }
            />
            <Route
              path="/salon-services"
              element={
                <SuspenseWrapper>
                  <SalonServices />
                </SuspenseWrapper>
              }
            />
            <Route
              path="/mobile-services"
              element={
                <SuspenseWrapper>
                  <MobileServices />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/wellness"
              element={
                <SuspenseWrapper>
                  <Wellness />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/about"
              element={
                <SuspenseWrapper>
                  <About />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/contact"
              element={
                <SuspenseWrapper>
                  <Contact />
                </SuspenseWrapper>
              }
            />

            {/* <Route
              path="/lash-extensions"
              element={
                <SuspenseWrapper>
                  <LashExtensions />
                </SuspenseWrapper>
              }
            /> */}

            <Route
              path="/events"
              element={
                <SuspenseWrapper>
                  <Events />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/careers"
              element={
                <SuspenseWrapper>
                  <Careers />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/vendors"
              element={
                <SuspenseWrapper>
                  <Vendors />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/reviews"
              element={
                <SuspenseWrapper>
                  <Reviews />
                </SuspenseWrapper>
              }
            />

            {/* Default route to redirect to */}
            <Route
              path="*"
              element={
                <SuspenseWrapper>
                  <Home />
                </SuspenseWrapper>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
